export const MODULE_SLUG = "S3Uploader";
export const MODULE_NAME = "S3Uploader";

export const API_URLS = {
	UPLOADER: {
		GET_SIGNED_URL: (name: string, type: string, communityName: string, noBucket: boolean) =>
			`/s3/sign?objectName=${name}&type=${type}${noBucket ? "" : `&bucket=yourvyoo-backgrounds/${communityName}`}`
	}
};
